import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as colors from './colors';
import prismDark from './prism/dark';
import prismLight from './prism/light';
export var light = _objectSpread({}, colors, {
  primary: colors.blue,
  text: colors.grayDark,
  muted: colors.gray,
  link: colors.blue,
  background: colors.white,
  border: colors.grayLight,
  sidebar: {
    bg: colors.white,
    navGroup: colors.grayDark,
    navLink: colors.grayDark,
    navLinkActive: colors.blue,
    tocLink: colors.gray,
    tocLinkActive: colors.grayExtraDark
  },
  header: {
    bg: colors.grayExtraLight,
    text: colors.grayDark,
    border: colors.grayLight,
    button: {
      bg: colors.blue,
      color: colors.white
    }
  },
  props: {
    bg: colors.grayUltraLight,
    text: colors.grayDark,
    highlight: colors.blue,
    defaultValue: colors.gray,
    descriptionText: colors.grayDark,
    descriptionBg: colors.white
  },
  playground: {
    bg: colors.white,
    border: colors.grayLight
  },
  blockquote: {
    bg: colors.grayExtraLight,
    border: colors.grayLight,
    color: colors.gray
  },
  prism: _objectSpread({}, prismLight)
});

if (typeof light !== 'undefined' && light && light === Object(light) && Object.isExtensible(light) && !light.hasOwnProperty('__filemeta')) {
  Object.defineProperty(light, '__filemeta', {
    configurable: true,
    value: {
      name: "light",
      filename: "node_modules/gatsby-theme-docz/src/theme/modes.js"
    }
  });
}

export var dark = _objectSpread({}, colors, {
  primary: colors.skyBlue,
  text: colors.grayExtraLight,
  muted: colors.gray,
  link: colors.skyBlue,
  background: colors.grayExtraDark,
  border: colors.grayDark,
  sidebar: {
    bg: colors.grayExtraDark,
    navGroup: colors.gray,
    navLink: colors.grayLight,
    navLinkActive: colors.skyBlue,
    tocLink: colors.gray,
    tocLinkActive: colors.grayLight
  },
  header: {
    bg: colors.dark,
    text: colors.grayLight,
    border: colors.grayDark,
    button: {
      bg: colors.skyBlue,
      color: colors.white
    }
  },
  props: {
    bg: colors.dark,
    text: colors.gray,
    highlight: colors.skyBlue,
    defaultValue: colors.grayDark,
    descriptionText: colors.gray,
    descriptionBg: colors.grayExtraDark
  },
  playground: {
    bg: colors.dark,
    border: colors.grayDark
  },
  blockquote: {
    bg: colors.grayDark,
    border: colors.gray,
    color: colors.gray
  },
  prism: _objectSpread({}, prismDark)
});

if (typeof dark !== 'undefined' && dark && dark === Object(dark) && Object.isExtensible(dark) && !dark.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dark, '__filemeta', {
    configurable: true,
    value: {
      name: "dark",
      filename: "node_modules/gatsby-theme-docz/src/theme/modes.js"
    }
  });
}